import { useRouteError } from "react-router-dom";
import { GenericErrorPageView } from "shared/components/empty/GenericErrorPageView";
import Page from "shared/components/layout/Page";
import PageBody from "shared/components/layout/PageBody";
import PageContainer from "shared/components/layout/PageContainer";
import PageContent from "shared/components/layout/PageContent";

export const AppRootRouteErrorPage: React.FC = () => {
  const error = useRouteError();
  return (
    <Page>
      <PageContainer>
        <PageContent isFullHeight={true}>
          <PageBody>
            <GenericErrorPageView error={error} />
          </PageBody>
        </PageContent>
      </PageContainer>
    </Page>
  );
};
